module.exports = "<h1 ng-bind-html=\"element.data.text\"></h1>"


//////////////////
// WEBPACK FOOTER
// ./sgcontenteditor/elements/title.html
// module id = 377
// module chunks = 0